import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-sku-found-confirm",
  templateUrl: "sku-found-confirm.component.html",
  standalone: false,
})
export class SkuFoundConfirmComponent extends BaseComponent {
  @Input() imageUrl: string;
  @Input() productTitle: string;
  @Input() sku: string;
  @Input() submitFn: Function;

  public closeText: string;

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService
  ) {
    super(userService);
    this.closeText = this.translate.instant("general.close");
  }

  submit() {
    if (this.submitFn) {
      this.submitFn();
    }
    this.activeModal.close();
  }
}
